import React from "react";

import { useTranslation } from 'react-i18next';

import { shortMonthNames } from '../../../components/DateTools/MonthsNames'
import { quantityTransformer } from '../../../utils/tools'

import BayphoneCanvasChart from './BayphoneCanvasChart';


const ChangeReasonChart = (props) => {
    const { t } = useTranslation('bayphone')
    const periodTransformer = shortMonthNames(t)

    const { symbol, periodStatistics } = props;

    function getChartPeriodLabel(period) {
        const dateParts = period.split("-");

        const year = dateParts[0].slice(-2);
        const month = parseInt(dateParts[1], 10);
        return `${periodTransformer[month - 1]}-${year}`;
    }

    function generateDataPoints(periodStatistics, presicion = 2) {
        const dataPoints = periodStatistics.map(stat => {
            return {
                period: stat.period.date,
                plannedBudget: stat.plannedBudget,
                changeReasonStatistics: stat.changeReasonStatistics
            }
        });

        if (!dataPoints || dataPoints.length === 0) {
            return [];
        }

        if (!dataPoints[0].changeReasonStatistics || dataPoints[0].changeReasonStatistics.length === 0) {
            return [{
                type: "column",
                name: t("No Data"),
                showInLegend: true,
                dataPoints: [{ label: t("No Data"), y: 0 }]
            }];
        }

        const changeReason = new Set();

        dataPoints.forEach((p) => {
            p.changeReasonStatistics.forEach((d) => changeReason.add(d.changeReason));
        });

        const changeReasonSeries = Array.from(changeReason).map((changeReason) => ({
            type: "stackedBar",
            name: changeReason,
            showInLegend: true,
            indexLabelPlacement: "inside",
            indexLabelFontColor: "black",
            click: function (e) {
                if (props.onChangePeriod) props.onChangePeriod(...e.dataPoint.period.split("-").map(arg => parseInt(arg, 10)))
            },
            dataPoints: dataPoints.map((p) => {
                const chgReason = p.changeReasonStatistics.find((d) => d.changeReason === changeReason);
                return {
                    label: getChartPeriodLabel(p.period),
                    period: p.period,
                    showInTooltip: true,
                    sumTotals: true,
                    y: chgReason ? chgReason.executedBudget : 0
                };
            })
        }));

        const totalSeries = {
            type: "stackedBar",
            name: t("Total"),
            showInLegend: false,
            color: "transparent",
            dataPoints: dataPoints.map((p) => {
                const total = p.changeReasonStatistics.reduce(
                    (sum, d) => sum + d.executedBudget,
                    0
                );
                return {
                    label: p.period,
                    y: 0,
                    showInTooltip: false,
                    indexLabel: `${symbol || ''} ${quantityTransformer(total, presicion || 0)}`,
                    indexLabelFontColor: "#000",
                    indexLabelFontWeight: "bold",
                    indexLabelFontSize: 11,
                    indexLabelPlacement: "outside"
                };
            })
        };

        return [...changeReasonSeries, totalSeries];
    }

    return (
        <BayphoneCanvasChart
            title={t("Expense by Change Reason")}
            symbol={symbol}
            presicion={2}
            dataPoints={generateDataPoints(periodStatistics)}
        />
    )
}

export default ChangeReasonChart;